import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <main className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found | HiredToday" description="This page doesn't exist." path="/404" />
      <p className="font-display text-7xl font-black text-zinc-200">404</p>
      <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-950 mt-4">Nothing here, we're afraid.</h1>
      <p className="mt-3 text-zinc-600">The page may have moved, or never existed. The jobs are all still where you left them.</p>
      <Link to="/" data-testid="not-found-home"
        className="mt-8 inline-block bg-zinc-950 text-white text-sm font-semibold px-8 py-3.5 rounded-md hover:bg-zinc-800 transition-colors duration-200">
        Back to the homepage
      </Link>
    </main>
  );
}
